import { render, staticRenderFns } from "./RulesSalesman.vue?vue&type=template&id=f6d6bd42&scoped=true&"
import script from "./RulesSalesman.vue?vue&type=script&lang=js&"
export * from "./RulesSalesman.vue?vue&type=script&lang=js&"
import style0 from "./RulesSalesman.vue?vue&type=style&index=0&id=f6d6bd42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d6bd42",
  null
  
)

export default component.exports